import { feedbackCollection } from '@/db/firestore';
import { FeedbackModel } from '@/models/feedback';

export class Feedback {
    public addFeedback(feedback: FeedbackModel) {
        return feedbackCollection.add(feedback);
    }
}